export default __webpack_public_path__ + "static/media/realAssets.323d59c9.svg";